import { combineReducers } from 'redux';
import managePurchaseOrder from './managePurchasseOrder/reducer';
import createEditReceipt from './createEditReceipt/reducer';

export default combineReducers({
  managePurchaseOrder,
  createEditReceipt,
});



// WEBPACK FOOTER //
// ./src/pages/inventory/managepurchaseorder/state/reducer.js